import React from "react";
import { useLocation, Navigate, Outlet } from "react-router-dom";
import { routingData } from "./routing";

import { useUser } from "./Usercontext";
import usePermission from "../config/permissions";
import { findRouteForRole } from "../config/roles";

const RedirectRouter = () => {
  // const { role } = useUser();
  const { role } = usePermission();
  const location = useLocation();

  if (!role) {
    return <Outlet />;
  }

  const roleObject = findRouteForRole(routingData, role);

  if (!roleObject?.defaultRoute) {
    return <Outlet />;
  }

  return (
    <Navigate to={roleObject.defaultRoute} state={{ from: location }} replace />
  );
};

export default RedirectRouter;
